import React, { useState } from 'react';
import './ChatComponents.css';

interface ChatFlashcardProps {
  front: string;
  back: string;
  hint?: string;
  topic?: string;
  onFollowUp?: (prompt: string) => void;
}

const ChatFlashcard: React.FC<ChatFlashcardProps> = ({
  front,
  back,
  hint,
  topic,
  onFollowUp
}) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [showHint, setShowHint] = useState(false);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const handleHintClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowHint(!showHint);
  };

  const handleFollowUp = (prompt: string) => {
    if (onFollowUp) {
      onFollowUp(prompt);
    }
  };

  return (
    <div className="chat-flashcard-wrapper">
      {/* Topic badge */}
      {topic && (
        <div className="flashcard-header">
          <span className="flashcard-badge">{topic}</span>
        </div>
      )}

      {/* Flashcard */}
      <div
        className={`chat-flashcard ${isFlipped ? 'flipped' : ''}`}
        onClick={handleFlip}
      >
        <div className="flashcard-inner">
          {/* Front side */}
          <div className="flashcard-front">
            <div className="flashcard-content">
              <p className="flashcard-text">{front}</p>
            </div>
            <div className="flashcard-footer">
              {hint && !isFlipped && (
                <button
                  className="hint-btn"
                  onClick={handleHintClick}
                >
                  {showHint ? '💡 ' + hint : '💡 Show Hint'}
                </button>
              )}
              <span className="flip-instruction">Tap to reveal answer</span>
            </div>
          </div>

          {/* Back side */}
          <div className="flashcard-back">
            <div className="flashcard-content">
              <p className="flashcard-text">{back}</p>
            </div>
            <div className="flashcard-footer">
              <span className="flip-instruction">Tap to flip back</span>
            </div>
          </div>
        </div>
      </div>

      {/* Follow-up actions */}
      <div className="flashcard-actions">
        <button
          className="follow-up-chip"
          onClick={() => handleFollowUp('Give me another flashcard on this topic')}
        >
          Another card
        </button>
        <button
          className="follow-up-chip"
          onClick={() => handleFollowUp('Quiz me on this term with an MCQ')}
        >
          Test me
        </button>
        <button
          className="follow-up-chip"
          onClick={() => handleFollowUp('Give me a memory trick for this')}
        >
          Memory trick
        </button>
      </div>
    </div>
  );
};

export default ChatFlashcard;
